import { useEffect } from 'react';
import {createImprintHash} from "../logger/imprintHash";
import {logForClickRules} from "../logger";
import {getImprint} from "../common";

export const useLogForClickRules = (rulesClick, imprintHash) => {
  useEffect(() => {
    if (imprintHash && rulesClick > 0) {
      logForClickRules(imprintHash);
    }
  }, [rulesClick])
}

export const useCreateImprintHash = (setState) => {
  useEffect(() => {
    createImprintHash()
      .then(res => {
        setState(res)
        return res
      })
      .then(res => getImprint(res))
      .catch(err => console.log(`Ошибка при запросе imprintHash: ${err}`));
  }, []);
}

export const useOutsideClickAlerter = (isVisible, ref, setIsVisible) => {
  useEffect(() => {
    if (isVisible) {
      const handleClickOutside = (e) => {
        if (ref.current && ref.current !== e.target) {
          setIsVisible(false);
        }
      }
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }
  }, [isVisible, ref, setIsVisible]);
}

export const useDisableBodyScroll = (open, ref, stickPosition, isBodyBackgroundColorChanged, color) => {
  useEffect(() => {
    const defineHeightValue = () => {
      if (stickPosition === 'bottom') {
        return '-100vh'
      }
      return '100vh'
    }

    if (open) {
      document.body.style.overflowY = 'hidden';
      if (isBodyBackgroundColorChanged && color) {
        document.body.style.backgroundColor = color;
      }
      if (ref) {
        ref.current.style.maxHeight = defineHeightValue();
      }
    } else {
      document.body.style.overflowY = 'unset';
      if (ref) {
        ref.current.style.maxHeight = 'unset';
      }
    }
  }, [open]);
};